import { DomainEvent } from '../../core/domain/events/domain_event';
import { IncomingMessage } from './incoming-message';

export class IncomingMessageEvent extends DomainEvent<IncomingMessage> {
  constructor(data: IncomingMessage) {
    super(data);
  }
}
